import { render } from "./PopUpWinner.vue?vue&type=template&id=86e55bb4"
import script from "./PopUpWinner.vue?vue&type=script&lang=js"
export * from "./PopUpWinner.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__